export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 130 },
  // { key: '2', headerName: 'State ID', field: 'id', hide: false, width: 250 },
  { key: '3', headerName: 'State', field: 'name', hide: false, width: 350 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 600 },
];
